import { ca } from '@cian/analytics';

import { selectFiltersStringified } from '../../../../selectors/offersHistory';
import { IThunkActionCreator } from '../../../../store';

/** 5. Взаимодействия с фильтрами */
function trackOffersHistoryFiltersChange(filters: string) {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `OffersHistoryFilters_${filters}_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

export const trackFiltersChange = (): IThunkActionCreator => (_, getState) => {
  const state = getState();
  const filtersStr = selectFiltersStringified(state);

  trackOffersHistoryFiltersChange(filtersStr);
};
